module.exports = __webpack_public_path__ + "img/leg-right-back.18fb591d.png";